import { NgModule } from '@angular/core';
import { AccountEditorDialogComponent } from './account-editor-dialog.component';
import { SharedModule } from '../../../../shared/shared.module';
import { CurrencyInputModule } from '../../../../shared/currency-input/currency-input.module';
import { StringValidatorsModule } from '../../../../../directives/validators/string/string-validators.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
    imports: [
        SharedModule,
        CurrencyInputModule,
        StringValidatorsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
    ],
    exports: [AccountEditorDialogComponent],
    declarations: [AccountEditorDialogComponent],
})
export class AccountEditorDialogModule
{
}
